import { render, staticRenderFns } from "./GStatisticsAllCompetencyGrowthChart.vue?vue&type=template&id=c49232aa&scoped=true&"
import script from "./GStatisticsAllCompetencyGrowthChart.vue?vue&type=script&lang=ts&"
export * from "./GStatisticsAllCompetencyGrowthChart.vue?vue&type=script&lang=ts&"
import style0 from "./GStatisticsAllCompetencyGrowthChart.vue?vue&type=style&index=0&id=c49232aa&scoped=true&lang=scss&"
import style1 from "./GStatisticsAllCompetencyGrowthChart.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49232aa",
  null
  
)

export default component.exports